import axios from "axios";
import { baseXoSoUrl } from "../config";

const apiRoot = String(baseXoSoUrl || "").replace(/\/$/, "");

const get = async (path, params = {}) => {
  const response = await axios.get(`${apiRoot}${path}`, { params });
  return response?.data;
};

class XosoService {
  getProvinces = async (region) => {
    try {
      const data = await get("/provinces", region ? { region } : {});
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getXsmb = async (params = {}) => {
    try {
      const data = await get("/xsmb", params);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getXsmt = async (params = {}) => {
    try {
      const data = await get("/xsmt", params);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getXsmn = async (params = {}) => {
    try {
      const data = await get("/xsmn", params);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getResultsByRegion = async (region, params = {}) => {
    if (region === "MB") return this.getXsmb(params);
    if (region === "MT") return this.getXsmt(params);
    return this.getXsmn(params);
  };

  getMega645 = async (params = {}) => {
    try {
      const data = await get("/vietlott/mega-6-45", params);
      return data && typeof data === "object" && data.id ? data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getPower655 = async (params = {}) => {
    try {
      const data = await get("/vietlott/power-6-55", params);
      return data && typeof data === "object" && data.id ? data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getDienToan123 = async (params = {}) => {
    try {
      const data = await get("/dien-toan/1-2-3", params);
      return data && typeof data === "object" && data.id ? data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getThanTai4 = async (params = {}) => {
    try {
      const data = await get("/dien-toan/than-tai-4", params);
      return data && typeof data === "object" && data.id ? data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getDienToan6x36 = async (params = {}) => {
    try {
      const data = await get("/dien-toan/6x36", params);
      return data && typeof data === "object" && data.id ? data : null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getLiveStatus = async (region) => {
    try {
      return await get(`/live/status/${region}`);
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  getLiveStreamUrl = (region) => `${apiRoot}/live/${region}`;

  getLotoFrequency = async (params = {}) => {
    try {
      const data = await get("/statistics/frequency", params);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getLotoGan = async (params = {}) => {
    try {
      const data = await get("/statistics/gan", params);
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  getHeadTailStats = async (params = {}) => {
    try {
      const data = await get("/statistics/head-tail", params);
      return data && typeof data === "object" ? data : { heads: {}, tails: {} };
    } catch (error) {
      console.error(error);
      return { heads: {}, tails: {} };
    }
  };
}

export const xosoService = new XosoService();
export default xosoService;
